<template>
    <v-container class="py-6">
        <v-row>
            <v-col cols="12">
                <h4 class="text-white text-center">โปรโมชั่น</h4>
            </v-col>

            <v-col cols="12" v-for="(item, index) in promotionList" :key="index">
                <div class="card-custom-wheel" @click="showPrmotionDetail(item)">
                    <div>
                        <v-img :src="item.PROMOTION_IMAGE" class="wheel-image"></v-img>
                    </div>
                    <div class="">
                        <h4 class="text-white fs-18">{{ item.PROMOTION_NAME }}</h4>
                    </div>
                    <div class="">
                        <span class="text-white fs-14">{{ item.PROMOTION_DES }}</span>
                    </div>
                    <div class="">
                        <span class="text-white fs-12">ข้อมูลเพิ่มเติม</span>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog" width="500">
            <!-- <template v-slot:activator="{ on, attrs }">
                <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on">
                    Click Me
                </v-btn>
            </template> -->

            <v-card class="custom-card-main">
                <v-card-title class="text-h5 bg-gold">
                    {{ prmotionDetail != null ?  prmotionDetail.PROMOTION_NAME  : ''}}
                </v-card-title>

                <div class="pa-2" v-if="prmotionDetail != null">
                    <v-img :src="prmotionDetail.PROMOTION_IMAGE" class="wheel-image"></v-img>
                </div>
                <div>
                    <v-card-text class="pa-2">
                        {{ prmotionDetail != null ? prmotionDetail.PROMOTION_DES : '' }}
                    </v-card-text>
                </div>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="danger" text @click="dialog = false">
                        ปิด
                    </v-btn>
                    <v-btn color="blue" text @click="confirmPromotion()">
                        รับโปรโมชั่น
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import { mapActions } from "vuex";
import { createToastInterface } from 'vue-toastification';
export default {

    components: {
    },
    computed: {

    },
    data() {
        return {
            promotionList: [],
            dialog: false,
            prmotionDetail: null
        }
    },
    mounted() {
        this.initPromotionList()
    },
    methods: {
        ...mapActions(['PromotionList', 'ConfirmReceiveCreditFree']),
        async initPromotionList() {
            let res = await this.PromotionList()
            if (res !== false) {
                if (res.Status == 'OK') {
                    this.promotionList = res.Data
                }
            }
        },
        showPrmotionDetail(item) {
            this.prmotionDetail = item
            this.dialog = true
        },
        async confirmPromotion() {
            if (this.prmotionDetail.PROMOTION_TYPE == 'CREDITFREE') {     
                let res = await this.ConfirmReceiveCreditFree(this.prmotionDetail.PROMOTION_ID)
                if (res !== false) {
                    if (res.Status == 'OK') {
                        createToastInterface().success(res.Msg)
                        this.dialog = false
                    } else {
                        createToastInterface().error(res.Msg)
                    }
                }
            } else {
                // go to payment page
                this.$router.push({ name: 'Payment', params: { promotionId: this.prmotionDetail.PROMOTION_ID } })
            }
       }
    }
}
</script>
<style lang="scss">
.frame-custom {
    height: calc(100vh - 136px) !important;
}
</style>
